import { render, staticRenderFns } from "./ConfirmDialogTemplate.vue?vue&type=template&id=4b297612&scoped=true&lang=pug&"
import script from "./ConfirmDialogTemplate.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialogTemplate.vue?vue&type=style&index=0&id=4b297612&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b297612",
  null
  
)

export default component.exports